const e = {
  inline: !0,
  group: "inline",
  selectable: !1,
  attrs: {
    id: { default: "" },
    class: { default: "embercom-prosemirror-composer-marker" }
  },
  toDOM(r) {
    return ["span", { id: r.attrs.id, class: r.attrs.class }];
  }
};
export {
  e as markerSpec
};
